import{$}from"@olmokit/dom/$";import{getDataAttr}from"@olmokit/dom/getDataAttr";import{setFormElementValue}from"../forms/helpers";/**
 * Get form data as query params
 */export function getPostData(data){let params=[];for(let name in data){let value=data[name];// FIXME: uncomment this check once fillform will be fixed to don't require
// non required fields
// if (value) {
params.push(encodeURIComponent(name)+"="+encodeURIComponent(value));// }
}return params.join("&")}/**
 * Get form data as object
 *
 * @see https://stackoverflow.com/q/11661187
 * @see https://vanillajstoolkit.com/helpers/serializearray/
 */export function getFormData(form){// Setup our serialized data
let output={};// Loop through each field in the form
for(let i=0;i<form.elements.length;i++){let element=form.elements[i],{name,value,type,checked/* disabled, */}=element;name&&// FIXME: (This might be fixed in the API). we pass everything now, even
// `disabled` fields as the API still requires a value for them. We might
// need to disable them in JavaScript, for instance when we have dependent
// fields and when one is hidden should also be disabled to adjust the
// `tabindex`. So we skip the `disabled` check keeping commented the line:
// disabled ||
"reset"!==type&&"submit"!==type&&"button"!==type&&("file"===type?(output[name]=getDataAttr(element,"filecontent")||"",output[`${name}_name`]=getDataAttr(element,"filename")||""):"checkbox"===type?output[name]=checked?"true":"false":("radio"!==type||checked)&&(output[name]=value))}return output}/**
 * Prefill form element data-attribute JSON encoded data
 *
 * @param {HTMLElement} element Clicked HTML element
 * @param {HTMLElement | Document | null} $formRoot Optional wrapper element around form
 */export function prefillFromElement(element,$formRoot){let raw=getDataAttr(element,"prefill");try{let data=JSON.parse(raw||"{}");for(let name in data){let value=data[name],$input=$(`[name='${name}']`,$formRoot);$input&&setFormElementValue($input,value)}// eslint-disable-next-line no-empty
}catch(e){}}/**
 * Check if in the form there a type=file input and if it is dirty
 */export function getTypeFile(form){// Loop through each field in the form
for(let i=0;i<form.elements.length;i++){let element=form.elements[i],{type,value}=element;if("file"===type&&""!==value)return!0}return!1}